/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentAuthor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2v20h7v-2H6V4h7v5h5v2h2V7.586L14.414 2zm11 3.414L16.586 7H15z" />
        <path d="M18.293 13.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L17.414 23H13v-4.414zM15 19.414V21h1.586l4-4L19 15.414zM7 16l2.945-7h1.11L14 16h-1.111l-.63-1.5H8.741L8.11 16zm3.5-5.68L9.163 13.5h2.674z" />
      </g>
    </g>
  </Icon>
);
export { SvgDocumentAuthor as DocumentAuthor };
